module.exports = __webpack_public_path__ + "static/img/Aaclogomax4.8ab78de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aaclogomax4.png
// module id = nf2/
// module chunks = 1